import { features } from 'reactApp/mail-features';

export const OverquotaUseApiStatus = features.has('overquota-use-api-status');
